import { FC, useState } from 'react';
import { Tr, CustomThemeDefinition } from '@utils';
import { Box, Button, Divider, Stack, Typography, useMediaQuery } from '@mui/material';
import { VoltaageModalDialog } from '@components/common';
import { ReactComponent as Illustration } from '@assets/illustrations/mobile-device.svg';

export const MobileDeviceNotificationDialog: FC = () => {
	const [dialogClosed, setDialogClosed] = useState(false);
	const isMobile = useMediaQuery<CustomThemeDefinition>((theme) => theme.breakpoints.down('md'));

	return (
		<VoltaageModalDialog
			title={<Tr.Portal path="common.mobile-device-notification.title" />}
			open={isMobile ? !dialogClosed : false}
			hideCloseIcon
			disablePortal
			maxWidth="sm"
			disableEscapeKeyDown
			sx={{ '&.MuiDialog-root': { position: 'absolute', margin: 0 } }}
			BackdropProps={{ sx: { '&.MuiBackdrop-root': { position: 'absolute', backdropFilter: 'blur(8px)' } } }}
		>
			<Divider light />
			<Stack direction="column" sx={{ paddingX: 6, paddingY: 4, alignItems: 'center' }} spacing={3}>
				<Box sx={{ marginX: 'auto' }}>
					<Illustration style={{ maxHeight: 140 }} />
				</Box>
				<Typography sx={{ paddingTop: 2 }}>

			
					<Tr.Portal path="common.mobile-device-notification.content" withInsecureTemplating />
				</Typography>
				<Divider light />
				<Button variant="contained" onClick={() => setDialogClosed(true)}>
					<Tr.Portal path="common.mobile-device-notification.cta" />
				</Button>
			</Stack>
		</VoltaageModalDialog>
	);
};
